/* 页面级全局权限校验方法*/
import store from '@/store';

/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
export default function checkPermission(value) {
  // 排除admin
  const roleflag = store.getters && store.getters.userinfo.role;
  if (roleflag === 'admin') {           //角色为admin 直接返回true结果 跳过之后js判断
    return true;
  }

  if (value && value instanceof Array && value.length > 0) {
    const roles = store.getters && store.getters.roles;
    const permissionRoles = value;
    const hasPermission = roles.some(role => {
      return permissionRoles.includes(role);
    });
    if (!hasPermission) {
      return false;
    }
    return true;
  } else {
    console.error(`非法操作!需要权限`);
    return false;
  }
}


// WEBPACK FOOTER //
// ./src/utils/permission.js